import React from "react";
import { Target, Trophy, Flame, Zap } from "lucide-react";
import { MetaColetivaStats } from "../types";

interface MetaAtingidaCardProps {
  metaColetiva: MetaColetivaStats;
}

export const MetaAtingidaCard: React.FC<MetaAtingidaCardProps> = ({
  metaColetiva,
}) => {
  const getStatusIcon = () => {
    if (metaColetiva.metaAtingida >= 100) {
      return (
        <span className="flex items-center justify-center gap-1 text-sm font-bold text-success">
          <Trophy size={16} className="text-success" />
          META SUPERADA!
        </span>
      );
    }
    if (metaColetiva.metaAtingida >= 80) {
      return (
        <span className="flex items-center justify-center gap-1 text-sm font-bold text-warning">
          <Flame size={16} className="text-warning" />
          QUASE LÁ!
        </span>
      );
    }
    return (
      <span className="flex items-center justify-center gap-1 text-sm font-bold text-info-light">
        <Zap size={16} className="text-info-light" />
        VAMOS ACELERAR!
      </span>
    );
  };

  return (
    <div className="relative overflow-hidden rounded-lg border-2 border-info/50 bg-neutral-800/60 p-4 shadow-2xl">
      <div className="absolute inset-0 animate-pulse bg-info/10" />
      <div className="relative z-10">
        <h3 className="mb-3 flex items-center justify-center gap-2 text-center text-sm font-bold tracking-wide text-info-light">
          <Target size={16} className="text-info" />
          META ATINGIDA COLETIVA
        </h3>

        <div className="mb-4 text-center">
          <span className="text-4xl font-black text-info sm:text-5xl">
            {metaColetiva.metaAtingida.toFixed(1)}%
          </span>
        </div>

        <div className="relative">
          <div className="h-6 overflow-hidden rounded-full border border-neutral-600/50 bg-neutral-700/50 shadow-inner">
            <div
              className="relative h-full w-[var(--meta-atingida-pct)] overflow-hidden rounded-full bg-info shadow-lg transition-all duration-1000 ease-out"
              style={
                {
                  "--meta-atingida-pct": `${Math.min(metaColetiva.metaAtingida, 100)}%`,
                } as React.CSSProperties
              }
            >
              <div className="absolute inset-0 animate-pulse bg-white/30" />
              <div className="absolute inset-0 rounded-full border border-white/20" />
            </div>
          </div>

          <div className="mt-1 flex justify-between text-xs text-neutral-400">
            <span>0%</span>
            <span className="font-semibold text-info-light">Meta: 100%</span>
          </div>
        </div>

        <div className="mt-3 text-center">{getStatusIcon()}</div>
      </div>
    </div>
  );
};
